/**
 * Angular imports
 */
import {Component, EventEmitter, OnInit, ViewChild} from 'angular2/core';
import {NgForm} from "angular2/common";
import {Router, RouteParams} from "angular2/router";

/**
 * Node module imports
 */
import {TranslatePipe, TranslateService} from "ng2-translate";

/**
 * Component imports
 */
import {CampaignCodesModalComponent} from "./../form/campaign_codes_modal.component";
import {Select2} from "../../common/select2/basic_select2.component";
import {Datepicker} from "../../common/datepicker/datepicker.component";
import {AbstractCampaignFormComponent} from "./../form/abstract_form_component";
import {SubmitButtonComponent} from "../../common/submit/submit_button.component";

/**
 * Model imports
 */
import {Country} from "../../../models/country.model";
import {Product} from "../../../models/product.model";

/**
 * Service imports
 */
import {KeycloakService} from "../../../http/keycloak.service";
import {CampaignService} from "../campaign.service";
import {ProductService} from "../../products/product.service";
import {CountryService} from "../../countries/country.service";
import {AlertService} from "../../common/alerts/alert.service";

@Component({
    templateUrl: './app/components/campaigns/form/form.html',
    providers: [CampaignService, CountryService, ProductService],
    directives: [CampaignCodesModalComponent, Select2, SubmitButtonComponent, Datepicker],
    pipes: [TranslatePipe]
})
export class NewCampaignComponent extends AbstractCampaignFormComponent implements OnInit {

    @ViewChild('campaignForm') campaignForm:NgForm;
    @ViewChild('countrySelect') countrySelect;
    @ViewChild('submitButton') submitButton;

    countries:Country[];
    products:Product[];

    emitter:EventEmitter<any> = new EventEmitter();

    /**
     * @constructor
     * @param {RouteParams} _params
     * @param {CampaignService} _campaignService
     * @param {ProductService} _productService
     * @param {AlertService} _alert_service
     * @param {Router} _router
     * @param {CountryService} _countryService
     * @param {TranslateService} _translateService
     * @param {KeycloakService} _keycloakService
     *
     * Get connected user canal
     */
    constructor(protected _params: RouteParams,
                protected _campaignService: CampaignService,
                protected _productService: ProductService,
                protected _alert_service: AlertService,
                protected _router: Router,
                protected _countryService: CountryService,
                protected _translateService: TranslateService,
                protected _keycloakService: KeycloakService) {
        super(_params, _campaignService, _productService, _alert_service, _router, _translateService);
        this.model.canal = this._keycloakService.getUser().canal;
    }

    ngOnInit() {
        this._countryService.getCountries().subscribe(countries => {
            this.countries = countries.map((country:Country) => {
                country.name = this._translateService.instant('countries.' + country.iso);
                return country;
             }).sort((a, b) => {
                return (a.name.localeCompare(b.name, window.localStorage.getItem("locale")));
             });
        }, error => {
            this._alert_service.pushAlert({type: "danger", msg: this._translateService.instant(error), closeable: true});
        });
    }

    onChangeCountry() {
        if (this.model.country === null) {
            this.products = [];
        } else {
            this._productService.getProducts(this.model.country).subscribe(products => this.products = products);
        }
    }

    submitCallback() {
        this.submitButton.toggleSpinner();
        this._campaignService.createCampaign(this.model).subscribe(id => {
            this.model.id = id;
            jQuery("#codesModal").modal("toggle");
            this.submitButton.toggleSpinner();
            this._alert_service.pushAlert({
                type: "success",
                msg: this._translateService.instant("campaigns.create.success"),
                closeable: true
            });
        }, error => {
            this._alert_service.pushAlert({type: "danger", msg: this._translateService.instant(error), closeable: true});
            this.submitButton.toggleSpinner();
        });
    }
}
